<div class="alarm-form-container">
    <div class="alarm-form-header" (click)="openSelect($event)">
        <h5 class="alarm-form-title" data-cy="channels-side-menu-alarm-settings-alarm-settings-section-label">
            {{ panelTitle | translate }}
        </h5>

        <mat-icon class="arrow" [class.focus]="isShowSelect" svgIcon="dropdown-arrow"></mat-icon>
    </div>

    <div
        *ngIf="
            isShowSelect &&
            (!isDigitalMotor || property === 'digitalAlarmSetting' || property === 'motorChannelSetting')
        "
        class="alarm-form-body">
        <div class="normal-enable-header">
            <h5 class="alarm-enable-title">
                {{ (setPointOnly ? 'channel.alarm.label.repose-enable' : 'channel.alarm.label.enable') | translate }}
            </h5>
            <mat-slide-toggle
                class="autosave-toggle"
                [disabled]="toggleDisabled"
                [checked]="selectedChannel.fcuData[property]?.enable"
                (change)="updateAlarmEnable($event)"></mat-slide-toggle>
        </div>
        <div class="status-setting" *ngIf="isDigitalContact" [class.disabled-section]="!isAlarmEnabled">
            <label class="title">
                {{ 'channel.alarm.label.normal.setting' | translate }}
            </label>

            <mat-radio-group
                class="status-options"
                [(ngModel)]="normalSetting"
                (ngModelChange)="onNormalSettingChange($event)">
                <mat-radio-button [value]="true" disableRipple>{{
                    'channel.alarm.label.normal.setting.contact.on' | translate
                }}</mat-radio-button>
                <mat-radio-button [value]="false" disableRipple>{{
                    'channel.alarm.label.normal.setting.contact.off' | translate
                }}</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="form-fields" [class.disabled-section]="!isAlarmEnabled">
            <app-channel-select-input
                *ngIf="!setPointOnly"
                name="alarmLevel"
                label="channel.alarm.form.alarm-level"
                [value]="alarmLevel[selectedChannel.fcuData[property].alarmLevel]"
                [itemList]="alarmLevelSelectList"
                (inputChange)="onInputChange($event)"
                [disabled]="
                    !selectedChannel.fcuData[property]?.enable || property === 'alarmSettingSensorFail'
                "></app-channel-select-input>

            <app-channel-text-input
                *ngIf="
                    !setPointOnly &&
                    (property === 'alarmSettingSensorFail' ||
                        property === 'alarmSettingVeryHigh' ||
                        property === 'alarmSettingHigh' ||
                        property === 'alarmSettingLow' ||
                        property === 'alarmSettingVeryLow')
                "
                name="statusString"
                label="channel.alarm.form.alarm-message"
                [value]="selectedChannel.fcuData[property].statusString"
                [maxLength]="ALARM_MESSAGE_MAX_LENGTH"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="handleFocusChanged()"
                placeholder="channel.alarm.form.alarm-message-placeholder"></app-channel-text-input>

            <app-channel-text-input
                *ngIf="panelTitle != 'channel.alarm.label.alarm-setting' && property !== 'alarmSettingSensorFail'"
                name="setPoint"
                label="channel.alarm.form.set-point"
                [value]="formatSetPoint(property)"
                [stripLeadingZeros]="true"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="handleFocusChanged()">
            </app-channel-text-input>
            <app-channel-text-input
                *ngIf="!setPointOnly"
                name="delayTimer"
                label="channel.alarm.form.delay"
                [value]="selectedChannel.fcuData[property].delayTimer"
                [stripLeadingZeros]="true"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="handleFocusChanged()"
                (onInputKeyDown)="integerOnlyKeyDown($event.event)"
                [inputValueValidation]="positiveWholeNumberValidation.bind(this)"
                unit="repose-group.page.print.seconds"></app-channel-text-input>
            <app-channel-text-input
                *ngIf="!setPointOnly"
                name="alarmGroupNo"
                label="channel.alarm.form.ext-g"
                [value]="selectedChannel.fcuData[property].alarmGroupNo"
                [stripLeadingZeros]="true"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="handleFocusChanged()"
                (onInputKeyDown)="integerOnlyKeyDown($event.event)"
                [inputValueValidation]="positiveWholeNumberValidation.bind(this)"></app-channel-text-input>
            <div class="repose-group-row" *ngIf="!setPointOnly">
                <app-channel-text-input
                    name="reposeGroup1No"
                    label="channel.alarm.form.g-rep1"
                    [value]="selectedChannel.fcuData[property].reposeGroup1No"
                    [stripLeadingZeros]="true"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="handleFocusChanged()"
                    (onInputKeyDown)="integerOnlyKeyDown($event.event)"
                    [inputValueValidation]="positiveWholeNumberValidation.bind(this)"></app-channel-text-input>

                <app-channel-text-input
                    name="reposeGroup2No"
                    label="channel.alarm.form.g-rep2"
                    [value]="selectedChannel.fcuData[property].reposeGroup2No"
                    [stripLeadingZeros]="true"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="handleFocusChanged()"
                    (onInputKeyDown)="integerOnlyKeyDown($event.event)"
                    [inputValueValidation]="positiveWholeNumberValidation.bind(this)"></app-channel-text-input>
            </div>
        </div>
    </div>
    <div
        *ngIf="
            isShowSelect && isDigitalMotor && property !== 'digitalAlarmSetting' && property !== 'motorChannelSetting'
        "
        class="alarm-form-body">
        <div class="form-fields">
            <app-channel-text-input
                name="motor"
                [label]="panelTitle"
                [value]="selectedChannel.fcuData.motorChannelSetting?.[property]"
                [maxLength]="MOTOR_STATUS_MAX_LENGTH"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="handleFocusChanged()"
                [inputValueValidation]="requiredValidation"
                [isDisabled]="!isRequiredField"></app-channel-text-input>
        </div>
    </div>
</div>
